// extracted by mini-css-extract-plugin
export default {"column":"styles__column--R9hyT","row":"styles__row--ikeTo","left":"styles__left--zz6Sf","main":"styles__main--ZDMla"};